import React, { useEffect, useState } from 'react';
import { Input, Button, Dropdown, List, Checkbox, Tag } from 'tea-component';
import { useIntl } from 'umi';
import './index.scss';

export default function TagSelecter(props: any) {
  const { selectedValue, onChange } = props;
  let tagSelectOptions = ['Politics', 'Cultural', 'Artistic', 'Sports'].map(
    (item) => ({ text: item, value: item }),
  );
  // 面板类型 select/customized
  const [activePanel, setActivePanel] = useState('select');
  const [tagValues, setTagValues] = useState(selectedValue);
  // 动态新增自定义tag
  const [tagOptions, setTagOptions] = useState(tagSelectOptions);

  const [inputError, setInputError] = useState(false);
  const [customizedValue, setCustomizedValue] = useState('');
  const { formatMessage } = useIntl();

  useEffect(() => {
    if (customizedValue != '') {
      setInputError(false);
    }
  }, [customizedValue]);

  const checkInput = () => {
    if (customizedValue == '') {
      setInputError(true);
    } else {
      let newTag = {
        text: customizedValue,
        value: customizedValue,
      };
      // 动态新增自定义tag
      tagSelectOptions.unshift(newTag);
      setTagOptions(tagSelectOptions);
      // 动态添加选择自定义tag
      tagValues.push(customizedValue);
      setTagValues(tagValues);
      // 切换下拉面板，重置
      setActivePanel('select');
      setCustomizedValue('');
      setInputError(false);
    }
  };

  useEffect(() => {
    onChange(tagValues);
  }, [tagValues]);

  return (
    <>
      <Dropdown
        className="dbo-tagselecter"
        button={
          <div className="dbo-tagselecter-inner">
            {tagValues.length > 0 ? (
              tagValues?.map((item: any, index: any) => (
                <Tag
                  className="dbo-tagselecter-value"
                  key={index}
                  onClose={() =>
                    setTagValues(tagValues.filter((tag: any) => tag !== item))
                  }
                >
                  {item}
                </Tag>
              ))
            ) : (
              <span className="select-button-text">
                {formatMessage({ id: 'Please select a Tag' })}
              </span>
            )}
          </div>
        }
        appearance="button"
        matchButtonWidth
        clickClose={false}
      >
        {(close) => (
          <>
            {activePanel == 'select' ? (
              <div className="dbo-tagselecter-select-wrap">
                <List type="option" className="dbo-tagselecter-selectbox">
                  <Checkbox.Group
                    value={tagValues}
                    onChange={(value) => setTagValues(value)}
                    layout="column"
                  >
                    {tagOptions?.map((item, index) => (
                      <Checkbox
                        key={index}
                        name={item.text}
                        tooltip={item.text}
                      >
                        {item.text}
                      </Checkbox>
                    ))}
                  </Checkbox.Group>
                </List>
                <div
                  className="dbo-tagselecter-footer"
                  onClick={() => {
                    setActivePanel('customized');
                  }}
                >
                  {formatMessage({ id: 'Customize' })}
                </div>
              </div>
            ) : (
              <div className="dbo-tagselecter-input-wrap">
                <div
                  className={`dbo-tagselecter-input ${
                    inputError ? 'error' : ''
                  }`}
                >
                  <Input
                    value={customizedValue}
                    maxLength={16}
                    onChange={(value, context) => {
                      setCustomizedValue(value);
                      console.log(value, context);
                    }}
                    placeholder={formatMessage({ id: 'Please input the tag' })}
                  />
                </div>
                {inputError ? (
                  <span className="text-error">
                    {formatMessage({ id: "Can't be null" })}
                  </span>
                ) : null}
                <div className="dbo-tagselecter-btngroup">
                  <Button
                    type="primary"
                    onClick={() => {
                      checkInput();
                    }}
                  >
                    {formatMessage({ id: 'Confirm' })}
                  </Button>
                  <Button
                    type="weak"
                    onClick={() => {
                      setActivePanel('select');
                    }}
                  >
                    {formatMessage({ id: 'Back' })}
                  </Button>
                </div>
              </div>
            )}
          </>
        )}
      </Dropdown>
    </>
  );
}
